export default "__VITE_ASSET__VmLi4hpr__"